/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @group Constants
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 * 
 * @example
 * ```typescript
 * import { MODULE_RESOURCES } from '@shared/utils';
 * 
 * // Use module resource constants
 * const resource = MODULE_RESOURCES.DATA;
 * ```
 */
export const MODULE_RESOURCES = {
  APP: 'app',
  DASHBOARD: 'dashboard',
  DOCS: 'docs',
  ERROR: 'error',
  HOME: 'home',
  MOBILE: 'mobile',
  PUBLIC: 'public',
  UNAUTHORIZED: 'unauthorized',
  USERS: 'users',
} as const;